import { useSEO, SEOInjection } from '@/hooks/useSEO';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import CategoriesSection from './components/CategoriesSection';
import StatsSection from './components/StatsSection';
import NewsSection from './components/NewsSection';
import PartnersSection from './components/PartnersSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useSEO({
    title: '豪门国际 - 通往顶级国际资源的首选平台 | 豪门国际官网',
    description: '豪门国际是您通往顶级国际资源的首选平台，汇聚全球豪门资源、高端商务合作与精英社交圈层，助您跨越国际边界，实现财富与地位的双重跃升。立即了解豪门国际，开启您的精英国际化之旅。',
    keywords: '豪门国际,豪门国际官网,豪门国际平台,豪门国际合作,国际豪门资源对接,高端国际商务圈,精英国际社交平台',
    canonical: window.location.origin + '/',
    ogTitle: '豪门国际 - 通往顶级国际资源的首选平台',
    ogDescription: '汇聚全球豪门资源、高端商务合作与精英社交圈层，助您跨越国际边界，实现财富与地位的双重跃升。',
    ogUrl: window.location.origin + '/',
  });

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '豪门国际',
    url: window.location.origin,
    description: '豪门国际是通往顶级国际资源的首选平台，汇聚全球豪门资源、高端商务合作与精英社交圈层。',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${window.location.origin}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '豪门国际',
    url: window.location.origin,
    description: '豪门国际是全球领先的高端资源整合平台，致力于为全球高净值人群与精英阶层提供顶级的国际资源对接、高端商务合作与精英社交服务。',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '金融街8号国际金融中心二期68楼',
      addressLocality: '中环',
      addressRegion: '香港',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+852-2888-8888',
      contactType: 'customer service',
      availableLanguage: ['Chinese', 'English'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '如何成为豪门国际的会员？', acceptedAnswer: { '@type': 'Answer', text: '我们采用邀请制与推荐制相结合的会员准入模式。您可以通过现有会员推荐，或直接联系我们的客户关系团队提交入会申请。我们会根据申请人的社会影响力、商业成就与个人信誉进行综合评估。' } },
      { '@type': 'Question', name: '豪门国际的核心服务区域包括哪些？', acceptedAnswer: { '@type': 'Answer', text: '我们的服务网络覆盖亚洲、欧洲、北美、中东及澳洲等60多个国家和地区，在香港、上海、新加坡、伦敦、纽约、迪拜等国际金融中心均设有联络处与合作机构。' } },
      { '@type': 'Question', name: '豪门国际如何保障会员隐私与信息安全？', acceptedAnswer: { '@type': 'Answer', text: '我们采用银行级别的信息加密技术，所有会员资料均存储于独立安全服务器，遵循最严格的隐私保护协议。' } },
      { '@type': 'Question', name: '是否可以帮助对接特定的商业资源或投资项目？', acceptedAnswer: { '@type': 'Answer', text: '当然可以。我们的专业顾问团队会根据您的具体需求，利用全球资源网络进行精准匹配，涵盖房地产、金融科技、新能源、医疗健康、文化艺术等多个领域。' } },
    ],
  };

  return (
    <>
      <SEOInjection jsonLd={webSiteSchema} />
      <SEOInjection jsonLd={orgSchema} />
      <SEOInjection jsonLd={faqSchema} />

      <main>
        <HeroSection />
        <ServicesSection />
        <CategoriesSection />
        <StatsSection />
        <NewsSection />
        <PartnersSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}